import { Component, inject } from '@angular/core';
import { TractorAttachmentTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractorAttachmentTypeCreateDto,
  TractorAttachmentTypeDto,
  TractorAttachmentTypeExcelDownloadDto,
  TractorAttachmentTypeUpdateDto,
} from '../proxy/general/dtos/tractor-attachment-type';
import { TRACTORATTACHMENTTYPE_CONFIG, TRACTORATTACHMENTTYPE_FIELDS } from './tractor-attachment-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tractor-attachment-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractorAttachmentTypeService, ConfirmationService],
  templateUrl: './tractor-attachment-type.html',
  styleUrl: './tractor-attachment-type.scss',
})
export class TractorAttachmentType extends BaseCrudComponent<
  TractorAttachmentTypeDto,
  TractorAttachmentTypeCreateDto,
  TractorAttachmentTypeUpdateDto,
  TractorAttachmentTypeExcelDownloadDto
> {
  service = inject(TractorAttachmentTypeService);
  config = TRACTORATTACHMENTTYPE_CONFIG;
  fields = TRACTORATTACHMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorAttachmentTypeDto): TractorAttachmentTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractorAttachmentType';
  }
}
